import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import { useRequests } from 'modules/request/hooks';
import { NEW } from 'enums/contextMenuEnum';
import { useAccountPreferences } from 'modules/scheduler/hooks';
import { useStyles } from './../styles';
import { FORM_NAME } from '../../../dropdowns/schedule/partials/resourceSingleMode';
import { store } from '../../../../../../store';
import { useDisabledTooltipLogic } from '../useDisabledTooltipLogic';
import { WrapWithTooltip } from '../wrapWithTooltip';
import { NewScheduleMenu } from '../../../contextMenu/schedule';

const RequestButton = React.forwardRef((props, schedulerRef) => {
    const { disabled, disabledTooltip, viewData } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const { canRequestResources, canRequestVacations } = useRequests();
    const { gridPreferences } = useAccountPreferences();
    const selectionExists = useSelector(state => state.scheduler.currentSelection.start);
    const isNewContextMenu = gridPreferences.contextMenu === NEW;
    const hasRights = canRequestVacations || canRequestResources;

    const { isDisabled, tooltip } = useDisabledTooltipLogic({
        disabled,
        disabledTooltip,
        selectionExists,
        hasRights,
        isNewContextMenu,
        isSchedule: false,
    });
    const classes = useStyles();

    const handleClick = event => {
        const formExists = !!store.getState().form?.[FORM_NAME];

        // First, it will be closed.
        if (formExists) {
            setTimeout(() => handleClick(event), 50);
        } else {
            setAnchorEl(event.currentTarget || event.target);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const isOpen = Boolean(anchorEl);

    return (
        <>
            <WrapWithTooltip tooltip={tooltip}>
                <Button
                    data-cy="scheduler-nav-buttons-request"
                    aria-controls="request-menu"
                    aria-haspopup="true"
                    className={classNames({ disabled: isDisabled })}
                    disabled={isDisabled}
                    onClick={handleClick}
                    endIcon={<ArrowDropDown />}
                    classes={classes}
                    disableRipple
                >
                    Request
                </Button>
            </WrapWithTooltip>
            {isOpen ? (
                <NewScheduleMenu
                    requestToolBarContext
                    onClose={handleClose}
                    schedulerRef={schedulerRef}
                    isOpen={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    viewData={viewData}
                />
            ) : null}
        </>
    );
});

RequestButton.propTypes = {
    windowHeight: PropTypes.number.isRequired,
    windowWidth: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
    disabledTooltip: PropTypes.string,
};

export default RequestButton;
